export default "__VITE_ASSET__BQBg$F$D__"